import { LaceThreadTypeService } from 'services/lace-thread-type-service';
import { LaceThreadDimensionService } from 'services/lace-thread-dimension-service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { bindable, bindingMode, containerless } from 'aurelia-framework';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Models } from 'models/core';
import { LaceThreadCategoryService } from 'services/lace-thread-category-service';
import { LaceThreadService } from 'services/lace-thread-service';
import { ErrorService } from 'services/error-service';
import { ToastService } from 'services/toast-service';

@containerless
@autoinject
export class LaceThreadFormInlineNew {
  @bindable private netId: number;
  private lacethread: Models.LaceThread = new Models.LaceThread();
  
  private lacethreadbreakingstrength: number;

  constructor(
    private laceThreadService: LaceThreadService,
    private laceThreadCategoryService: LaceThreadCategoryService,
    private laceThreadDimensionService: LaceThreadDimensionService,
    private laceThreadTypeService: LaceThreadTypeService,
    private eventAggregator: EventAggregator,
    private router: Router,
    private toastService: ToastService,
    private errorService: ErrorService
  ) {}

  private attached() {}

  private createLaceThread() {
    this.lacethread.NetId = this.netId;
    this.laceThreadService
      .post(this.lacethread)
      .then((res) => {
        this.eventAggregator.publish('laceThreadListReset', 1);
        this.eventAggregator.publish('laceThreadFormNewClose', 1);
        this.toastService.showSuccess('laceThread.created');
        this.lacethread = new Models.LaceThread();
      })
      .catch((err) => this.errorService.handleError(err));
  }

  private cancel() {
    this.eventAggregator.publish('laceThreadFormNewClose', 1);
  }
}
